import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ReviewTrackersService } from "../../services/review-trackers.service";

@Component({
    selector: 'app-feedback-section',
    templateUrl: './feedback-section.component.html',
    styleUrls: ['./feedback-section.component.scss']
})
export class FeedbackSectionComponent implements OnChanges {
    @Input() merchantId: number;
    @Input() rating: number = 4.8;
    @Input() totalReviews: number = 534;
    @Input() maxStars = 5;
    @Input() reviewUrl: string = `https://search.google.com/local/writereview?placeid=ChIJNzBX42uDxYkRbFRLPZQ4u20`;
    @Input() config!: { leaveReview: boolean; netPromoterScore: boolean; customerSatisfaction: boolean };

    constructor(private reviewTrackersService: ReviewTrackersService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        // if (changes['merchantId'] && this.merchantId) {
        //     this.reviewTrackersService.reviewStatsForReceipt(this.merchantId.toString(), ['Google']).subscribe(stats => {
        //         this.totalReviews = stats.totalReviews;
        //         this.rating = stats.rating;
        //         if (stats.location.googlePlaceId)
        //             this.reviewUrl = `https://search.google.com/local/writereview?placeid=${stats.location.googlePlaceId}`;
        //     });
        // }
    }

    get ratingPercentage(): number {
        return (4.65 / this.maxStars) * 100;
    }

    get starsArray(): number[] {
        return Array(this.maxStars)
            .fill(0).map((x, i) => i);
    }

    onLeaveReview(): void {
        window.open(this.reviewUrl, '_blank');
    }

    public selectEmoji(button: HTMLButtonElement): void {
        const allButtons = document.querySelectorAll('.emoji-button') as NodeListOf<HTMLButtonElement>;
        allButtons.forEach((btn: HTMLButtonElement) => {
            btn.classList.remove('selected');
        });
        button.classList.add('selected');
    }

    public selectNPS(button: HTMLButtonElement): void {
        const allButtons = document.querySelectorAll('.nps-button') as NodeListOf<HTMLButtonElement>;
        allButtons.forEach((btn: HTMLButtonElement) => {
            btn.classList.remove('selected');
        });
        button.classList.add('selected');
    }
}